<template>
    <div class="toast" v-show="show">
        {{message}}
    </div>
</template>

<script>
export default {
    data() {
        return {
            message: '',
            show: false
        }
    }
}
</script>

<style lang="stylus" scoped>
.toast
    position fixed
    z-index 9999
    left 50%
    top 50%
    transition all .5s
    text-align center
    border-radius 5px
    color #FFF
    font-size 0.28rem
    background rgba(17, 17, 17, 0.7)
    padding 0.15rem 0.3rem
    -webkit-transform translateX(-50%) translateY(-50%)
    -moz-transform translateX(-50%) translateY(-50%)
    -ms-transform translateX(-50%) translateY(-50%)
    -o-transform translateX(-50%) translateY(-50%)
    transform translateX(-50%) translateY(-50%)
</style>